<div *ngIf='form as form' [formGroup]='form'>
  <fieldset>
    <legend>Dane podstawowe</legend>
    <div class='row'>
      @if (form.surfaceViolation) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"surfaceViolation" as controlName'>
            <label [for]='controlName'>Rodzaj *</label>
            <select
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz rodzaj</option>
              <option value='Bez naruszenia nawierzchni'>Bez naruszenia nawierzchni</option>
              <option value='Powodujące naruszenie nawierzchni'>Powodujące naruszenie nawierzchni</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.occupationType) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"occupationType" as controlName'>
            <label [for]='controlName'>Rodzaj *</label>
            <select
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz rodzaj</option>
              <option *ngFor='let item of roadOccupationTypes()' [value]='item?.id'>
                {{ item?.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.city) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"city" as controlName'>
            <label [for]='controlName'>
              Miejscowość
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu miejscowość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.purpose) {
        @if (purposeControlType === 'input') {
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"purpose" as controlName'>
              <label [for]='controlName'>
                Cel zajęcia *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu cel zajęcia'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (purposeControlType === 'textarea') {
          <div class='col-12'>
            <div class='form-group' *ngIf='"purpose" as controlName'>
              <label [for]='controlName'>
                Cel zajęcia *
              </label>
              <textarea
                rows="4"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu cel zajęcia'>
              </textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      }
      @if (form.workPurpose) {
        @if (workPurposeControlType === 'select') {
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"workPurpose" as controlName'>
              <label [for]='controlName'>Cel prowadzenia robót *</label>
              <select
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [id]='controlName'
                [formControlName]='controlName'>
                <option value=''>Wybierz cel</option>
                <option value='Umieszczenie kontenera'>Umieszczenie kontenera</option>
                <option value='Umieszczenie rusztowania'>Umieszczenie rusztowania</option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (workPurposeControlType === 'textarea') {
          <div class='col-12'>
            <div class='form-group' *ngIf='"workPurpose" as controlName'>
              <label [for]='controlName'>
                Cel prowadzenia robót *
              </label>
              <textarea
                rows="5"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu cel prowadzenia robót'></textarea>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      }
      @if (form.typeOfFailure) {
        <div class='col-md-8'>
          <div class='form-group' *ngIf='"typeOfFailure" as controlName'>
            <label [for]='controlName'>
              Rodzaj awarii *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu rodzaj awarii'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
  </fieldset>
  <br>
  @if (form.locationDecisions; as locationDecisions) {
    <fieldset>
      <legend>
        Decyzje
      </legend>
      <app-location-decisions-crud [formControl]="locationDecisions">
      </app-location-decisions-crud>
    </fieldset>
    <br>
  }
  <fieldset>
    <legend>
      Etapy
    </legend>
    <app-tab-view
      [simple]='false'
      (onAddNew)='form.addStage()'
      addBtnTitle='Dodaj kolejny etap'
      [showAddButton]='true'
      [centered]='true'
      formArrayName='stages'>
      <ng-container *ngFor='let stageForm of form.getStageForms(); let i = index;'>
        <app-tab-panel
          (onClose)='form.removeStage(i)'
          [closeBtnDisabled]='i === 0'
          [showCloseBtn]='true'
          [name]='"Etap nr " + (i + 1)' [selected]='i === (form.stages.controls.length - 1)'>
          <app-stage-form
            [serviceId]="serviceId()"
            [label]='"Etap nr " + (i + 1)'
            [canRemoveStage]='i !== 0'
            [form]='stageForm'>
          </app-stage-form>
        </app-tab-panel>
      </ng-container>
    </app-tab-view>
  </fieldset>
</div>
